import { connect } from 'react-redux'
import SignUp from './SignUp'

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUp)
